import Vue from 'vue'
import Router from 'vue-router'
// import auth from '@/auth/authService'

// import firebase from '@firebase/app'
import '@firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard'
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },

        // Cashflow Management (native E-Balance API)
        {
          path: '/cashbook/:cashbookType',
          name: 'cash-book',
          component: () => import('@/views/cashbooks/Index.vue'),
          meta: { rule: 'editor', authRequired: true }
        },
        {
          path: '/user-company-mappings',
          name: 'user-company-mappings',
          component: () => import('@/views/user-company-mappings/Index.vue'),
          meta: { rule: 'superadmin', authRequired: true }
        },
        {
          path: '/balance-reconciliation',
          name: 'balance-reconciliation',
          component: () => import('@/views/balance-reconciliation/Index.vue'),
          meta: { rule: 'superadmin', authRequired: true }
        },
        {
          path: '/cashbook/:cashbookType/cashflows/:cashbookId',
          name: 'cash-book-cashflows',
          component: () => import('@/views/cashflows/Index.vue'),
          meta: { parent: 'cash-book', rule: 'editor', authRequired: true }
        },
        {
          path: '/cashbook/:cashbookType/cashflows/:cashbookId/add',
          name: 'cash-book-cashflows-add',
          component: () => import('@/views/cashflows/Add.vue'),
          meta: { parent: 'cash-book', rule: 'editor', authRequired: true }
        },
        {
          path: '/cashbook/:cashbookType/cashflows/edit/:id',
          name: 'cash-book-cashflows-edit',
          component: () => import('@/views/cashflows/Edit.vue'),
          meta: { parent: 'cash-book', rule: 'editor', authRequired: true }
        },
        {
          path: '/cash-book-temporary',
          name: 'cash-book-temporary',
          component: () => import('@/views/cashbooks-temporary/Index.vue'),
          meta: { rule: 'editor', authRequired: true }
        },
        {
          path: '/cash-book-temporary/add',
          name: 'cash-book-temporary-add',
          component: () => import('@/views/cashbooks-temporary/Add.vue'),
          meta: { parent: 'cash-book-temporary', rule: 'editor', authRequired: true }
        },
        {
          path: '/cash-book-temporary/edit/:id',
          name: 'cash-book-temporary-edit',
          component: () => import('@/views/cashbooks-temporary/Edit.vue'),
          meta: { parent: 'cash-book-temporary', rule: 'editor', authRequired: true }
        },
        {
          path: '/cash-book-temporary/detail/:id',
          name: 'cash-book-temporary-detail',
          component: () => import('@/views/cashbooks-temporary/Detail.vue'),
          meta: { parent: 'cash-book-temporary', rule: 'editor', authRequired: true }
        },
        {
          path: '/bank',
          name: 'bank',
          component: () => import('@/views/bank/Index.vue'),
          meta: { rule: 'editor', authRequired: true }
        },
        {
          path: '/bank-account/detail/:id',
          name: 'bank-account-detail',
          component: () => import('@/views/bank-account/Index.vue'),
          meta: { parent: 'bank', rule: 'editor', authRequired: true }
        },
        {
          path: '/bank-account-cashflow/:id',
          name: 'bank-account-cashflow',
          component: () => import('@/views/bank-account-cashflow/Index.vue'),
          meta: { parent: 'bank', rule: 'editor', authRequired: true }
        },
        {
          path: '/bank-account-cashflow/add/:id',
          name: 'bank-account-cashflow-add',
          component: () => import('@/views/bank-account-cashflow/Add.vue'),
          meta: { parent: 'bank', rule: 'editor', authRequired: true }
        },
        {
          path: '/bank-account-cashflow/edit/:id',
          name: 'bank-account-cashflow-edit',
          component: () => import('@/views/bank-account-cashflow/Edit.vue'),
          meta: { parent: 'bank', rule: 'editor', authRequired: true }
        },

        {
          path: '/account-number',
          redirect: '/accounts-number'
        },
        {
          path: '/accounts-number',
          name: 'accounts-number',
          component: () => import('@/views/accounts-number/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/manage-coa',
          name: 'manage-coa',
          component: () => import('@/views/accounts-number/ManageCoa.vue'),
          meta: {
            rule: 'financialAdmin',
            authRequired: true
          }
        },

        {
          path: 'journal-vouchers',
          name: 'journal-vouchers',
          component: () => import('@/views/journal-voucher/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'journal-vouchers/add',
          name: 'journal-vouchers-add',
          component: () => import('@/views/journal-voucher/Add.vue'),
          meta: {
            parent: 'journal-vouchers',
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: 'journal-vouchers/edit/:id',
          name: 'journal-vouchers-edit',
          component: () => import('@/views/journal-voucher/Edit.vue'),
          meta: {
            parent: 'journal-vouchers',
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: 'report-settings',
          name: 'report-settings',
          component: () => import('@/views/report-settings/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: 'report-settings/add',
          name: 'report-settings-add',
          component: () => import('@/views/report-settings/Add.vue'),
          meta: {
            parent: 'report-settings',
            rule: 'financialAdmin',
            authRequired: true
          }
        },


        {
          path: 'report-settings/edit/:id',
          name: 'report-settings-edit',
          component: () => import('@/views/report-settings/Edit.vue'),
          meta: {
            parent: 'report-settings',
            rule: 'financialAdmin',
            authRequired: true
          }
        },

        {
          path: 'general-ledgers',
          name: 'general-ledgers',
          component: () => import('@/views/general-ledger/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: 'sub-general-ledgers/:id',
          name: 'sub-general-ledgers',
          component: () => import('@/views/sub-general-ledger/Index.vue'),
          meta: {
            parent: 'general-ledgers',
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: 'financial-statements',
          name: 'financial-statements',
          component: () => import('@/views/financial-statement/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: 'income-statements',
          name: 'income-statements',
          component: () => import('@/views/income-statement/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        }
      ]
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: '/companies',
          name: 'companies',
          component: () => import('@/views/companies/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },

        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {

  const loggedIn  = localStorage.getItem('accessToken')
  const company   = localStorage.getItem('activeCompany')

  if (to.meta.authRequired) {
    if (!loggedIn) {
      router.push({ path: '/login' })
    } else if (to.name !== 'companies') {
      if (company === null) {
        router.push({path: '/companies'})
      }
    }
  }

  return next()

})

export default router
